/****************************************************
 * Module Name:  shapeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ShapeProxy {
  static GetAllShape = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shape",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllShapeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shape/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllEnabledShapeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shape/mini/enabled",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleShape = (shapeId, callback) => {
    let params = {
      id: shapeId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/shape",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckShapeAvailable = (shape, callback) => {
    let params = {
      shape: shape,
    };

    restAPICall(
      Constants.MANAGER_URL + "/shape/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddShape = (shape, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shape",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(shape),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateShape = (shape, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/shape",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(shape),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UploadShapeImage = (shapeId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/shape/upload/${shapeId}`,
      "post",
      Constants.userToken,
      undefined,
      data,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
